// extracted by mini-css-extract-plugin
module.exports = {"section":"ComponentSection_section__sjSru","custom":"ComponentSection_custom__W1e8t"};